import { useProposalContext } from "contexts/proposal"

import * as trackers from "./trackings"

const useCardMiddle = () => {
  const { cpfData } = useProposalContext()

  const { hashedCpf } = cpfData

  const handleTrackEvent = () => {
    trackers.openAccount(hashedCpf)
  }

  return {
    handleTrackEvent
  }
}

export default useCardMiddle
